import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.string.includes.js';
import { __awaiter } from '../../_virtual/_tslib.js';
import Cookies from 'js-cookie';
import decodeToken from 'jwt-decode';
import { Envs } from '../envs.js';

class UpdatedTokenAttributes {
  constructor(auth) {
    this.auth = auth;
  }
  execute() {
    return __awaiter(this, void 0, void 0, function* () {
      const token = yield this.getToken();
      if (!token) return null;
      yield this.updateStorageToken(token);
      return this.parseToData(token);
    });
  }
  getToken() {
    return __awaiter(this, void 0, void 0, function* () {
      // when next
      if (this.isSiteDomain()) {
        const session = Cookies.get('__session');
        return session;
      }
      return yield this.auth.getToken();
    });
  }
  updateStorageToken(token) {
    return new Promise(resolve => {
      var _a;
      const userStorage = JSON.parse((_a = localStorage.getItem('authUser')) !== null && _a !== void 0 ? _a : '{}');
      localStorage.setItem('authUser', JSON.stringify(Object.assign(Object.assign({}, userStorage), {
        accessToken: token
      })));
      if (!this.isSiteDomain()) {
        Cookies.set('__session', token, {
          expires: 15,
          domain: Envs.COOKIE_DOMAIN
        });
      }
      resolve(true);
    });
  }
  parseToData(token) {
    var _a;
    const attributes = (_a = decodeToken(token)) !== null && _a !== void 0 ? _a : {};
    const attributesRoleplayUserId = attributes === null || attributes === void 0 ? void 0 : attributes.roleplayUserId;
    const attributesResource = attributes === null || attributes === void 0 ? void 0 : attributes.roleplayResources;
    if (!attributesRoleplayUserId || !attributesResource) return null;
    return {
      token,
      roleplayUserId: attributesRoleplayUserId,
      roleplayResources: attributesResource
    };
  }
  // Check if is site next domain
  isSiteDomain() {
    var _a, _b;
    return (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin) === null || _b === void 0 ? void 0 : _b.includes(Envs.SITE_URL);
  }
}

export { UpdatedTokenAttributes };
